// extracted by mini-css-extract-plugin
export default {"posts-block":"postBlock_posts-block__wXHH7","old-posts":"postBlock_old-posts__9h2q7"};